// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"603a8eba","455":"db529d41"}[chunkId] + ".chunk.js";
};